import { render, staticRenderFns } from "./FbScorm.vue?vue&type=template&id=5566a89f"
import script from "./FbScorm.vue?vue&type=script&lang=js"
export * from "./FbScorm.vue?vue&type=script&lang=js"
import style0 from "./FbScorm.vue?vue&type=style&index=0&id=5566a89f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports